module.exports = __webpack_public_path__ + "img/sms.2d0de610.svg";